import useGetCategories from "actions/quiz/useGetCategories";
import React, { createContext, useEffect, useMemo, useState } from "react";

type QuizContextProviderProps = {
  children: React.ReactNode;
};

type QuizContextProps = {
  questionIndex: number;
  setQuestionIndex: React.Dispatch<React.SetStateAction<number>>;
  categoryIndex: number;
  setCategoryIndex: React.Dispatch<React.SetStateAction<number>>;
  categories: CategoryEntity[] | undefined;
  setCategories: React.Dispatch<
    React.SetStateAction<CategoryEntity[] | undefined>
  >;

  currentQuestion: QuestionEntity | undefined;
  currentCategory: CategoryEntity | undefined;
};

export const QuizContext = createContext<QuizContextProps>({
  questionIndex: 0,
  setQuestionIndex: () => {},
  categoryIndex: 0,
  setCategoryIndex: () => {},
  categories: undefined,
  setCategories: () => {},

  currentQuestion: undefined,
  currentCategory: undefined,
});

export default function QuizProvider({ children }: QuizContextProviderProps) {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState<
    QuestionEntity | undefined
  >();
  const [currentCategory, setCurrentCategory] = useState<
    CategoryEntity | undefined
  >();

  const [categories, setCategories] = useState<CategoryEntity[] | undefined>();

  const { data: categoriesData } = useGetCategories();

  const cachedCategoriesData = useMemo(() => categoriesData, [categoriesData]);

  useEffect(() => {
    setCategories(cachedCategoriesData);
    setCurrentCategory(cachedCategoriesData?.[categoryIndex]);
    setCurrentQuestion(
      cachedCategoriesData?.[categoryIndex]?.questions[questionIndex],
    );
  }, [cachedCategoriesData, categoryIndex, questionIndex]);

  return (
    <QuizContext.Provider
      value={{
        questionIndex,
        setQuestionIndex,
        categoryIndex,
        setCategoryIndex,
        categories,
        setCategories,
        currentQuestion,
        currentCategory,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
}
